import { useState } from "react";
import { ChevronDown } from "lucide-react";

const Collapse = ({ title, icon: Icon, badge, subtitle, testid, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="mt-8 max-w-5xl">
      <button data-testid={testid} onClick={() => setOpen(!open)}
        className={`w-full flex items-center justify-between bg-pb-surface border px-5 py-4 transition-colors ${open ? "border-pb-red" : "border-pb-border hover:border-pb-red/60"}`}>
        <span className="flex items-center gap-2.5 font-display font-bold text-xl uppercase text-left">
          {Icon && <Icon className="w-5 h-5 text-pb-red shrink-0" />} {title} {badge}
        </span>
        <ChevronDown className={`w-5 h-5 text-zinc-500 shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="border border-t-0 border-pb-border bg-pb-base/30 p-5 animate-fade-up">
          {subtitle && <p className="text-sm text-zinc-500 mb-4">{subtitle}</p>}
          {children}
        </div>
      )}
    </div>
  );
};

export default Collapse;
